import { DemographicCondition } from '@/types/ReportRun';

export function normalizeOshDemographics(values?: any[]): DemographicCondition[] {
    if (!Array.isArray(values)) return [];

    return values
        .map((value: any) => {
            if (!value) return undefined;

            if (value.demographic) {
                return {
                    demographic: value.demographic,
                    condition: value.condition ?? 'is',
                    value: Array.isArray(value.value) ? value.value : [],
                    data: value.data ?? {},
                } as DemographicCondition;
            }

            if (typeof value === 'string') {
                return {
                    demographic: value,
                    condition: 'is',
                    value: [],
                    data: {},
                } as DemographicCondition;
            }

            if (value.display || value.value) {
                const demographic = value.value ?? value.display;
                return {
                    demographic,
                    condition: 'is',
                    value: [],
                    data: value,
                } as DemographicCondition;
            }

            return undefined;
        })
        .filter(Boolean) as DemographicCondition[];
}
